import { useEffect, useState } from 'react'
import CardGrid from '../../public/components/CardGrid'
import { API_URL } from '../../constants'
import { useNavigate } from 'react-router-dom'
import Card from '../../public/components/Card'
import TableView from '../../shared/components/TableView'
import { Button } from '../../shared/components/Button'
import { exportToExcel } from '../../util/exportFunction'
import { useTranslation } from 'react-i18next'
import { languageUtil } from '../../util/languageUtils'
import { LoadingOverlay } from '../../shared/components/Loading'

const EditableListPage = ({
    title,
    endpoint,
    token = localStorage.getItem('token'),
    view = 'card', // card || table
    renderCard,
    renderTable,
    customHeaders = {},
    rowLink = '',
    navLinkPrefix = endpoint, //only state in parent if different from endpoint
    exportEnabled = false,
    buttons = <></>,
}) => {
    const [items, setItems] = useState([])
    const [loading, setLoading] = useState(true)

    const { t } = useTranslation()
    const { language } = languageUtil()

    const navigate = useNavigate()

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`${API_URL}/${endpoint}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Accept-Language': language,
                        ...customHeaders,
                    },
                })
                const json = await response.json()

                if (json.success && Array.isArray(json.data)) {
                    setItems(json.data)
                } else {
                    console.error('Invalid data structure:', json)
                }
            } catch (error) {
                console.error('Failed to fetch:', error)
            } finally {
                setLoading(false)
            }
        }

        fetchData()
    }, [endpoint, token, language])

    const defaultRenderCard = item => (
        <Card
            key={item.id}
            imageSrc={item.image_preview}
            label={item.title}
            description={item.subtitle}
            buttonLabel={item.call_to_action}
            onButtonClick={() => navigate(`${navLinkPrefix}/${item.id}`)}
        />
    )

    const defaultRenderTable = (items, navigate) => {
        const columns = [
            { key: 'id', label: 'ID' },
            { key: 'title', label: 'Title' },
            { key: 'subtitle', label: 'Subtitle' },
            { key: 'call_to_action', label: 'CTA' },
        ]

        const handleRowClick = item => {
            navigate(`${rowLink}/${item.id}`)
        }

        return <TableView data={items} columns={columns} onRowClick={handleRowClick} />
    }

    return (
        <div className='w-full p-6 bg-white border shadow-md rounded-xl'>
            <div className='flex justify-between md:mb-12'>
                <h2 className='text-2xl font-bold text-gray-800'>{title}</h2>
                <div className='flex items-center gap-3'>
                    {exportEnabled && (
                        <Button onClick={() => exportToExcel(items, title)}>
                            {t('status.export')}
                        </Button>
                    )}
                    {buttons}
                </div>
            </div>
            {loading ? (
                <LoadingOverlay message={t('loading')} />
            ) : items.length === 0 || !items ? (
                <p>{t('status.no_items')}</p>
            ) : view === 'card' ? (
                <CardGrid data={items} renderCard={renderCard || defaultRenderCard} />
            ) : (
                (renderTable || (items => defaultRenderTable(items, navigate)))(items)
            )}
        </div>
    )
}

export default EditableListPage
